// extracted by mini-css-extract-plugin
var _1 = "InhabitantTableLayout-modulepageActions__ApH_o PageActions-modulePageActions__lL8Sl";
export { _1 as "pageActions" }
